/* ─────────────────────  src/App.js  ───────────────────── */
import "./App.css";
import Header from "./components/common/header/Header";
import ScrollToTop from "./components/common/ScrollToTop";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import About from "./components/about/About";
import CourseHome from "./components/allcourses/CourseHome";
import Team from "./components/team/Team";
import Blog from "./components/blog/Blog";
import Contact from "./components/contact/Contact";
import Footer from "./components/common/footer/Footer";
import Home from "./components/home/Home";
import Faq from "./components/pricing/Faq";
import Country from "./pages/Country/Country";
import Destinations from "./pages/Country/Destinations";
import Services from "./pages/Services/Services";
import VisaAssistance from "./pages/Services/VisaAssistance";
import Accommodation from "./pages/Services/Accommodation";
import CareerCounseling from "./pages/Services/CareerCounseling";
import TestPreparation from "./pages/Services/TestPreparation";
import DocumentVerification from "./pages/Services/DocumentVerification";
import TravelInsurance from "./pages/Services/TravelInsurance";
import Layout from "./components/common/Layout";
import NotFound from "./components/common/NotFound";
import StudyAbroadGuide from "./components/seo/StudyAbroadGuide";
import LocalSeoGuide from "./components/seo/LocalSeoGuide";
import { AuthProvider, useAuth } from "./contexts";
import { useState, useEffect, useMemo } from "react";
import LoginSignupModal from "./components/login/login";

import Course from "./components/allcourses/Course";
import AllBlogs from "./pages/AllBlogs/AllBlogs";
import Blogs from "./components/Blogs/Blogs";
import Events from "./components/events/Events";
import PrivacyPolicy from "./components/policies/PrivacyPolicy";
import TermsOfService from "./components/policies/TermsOfService";

import {
  faq as faqDefault,
  faqHome,
  faqCourses,
  faqServices,
  faqVisa,
  faqAccommodation,
  faqCareer,
  faqTestPrep,
  faqDocuments,
  faqInsurance,
  faqCountry,
  faqBlog,
  faqContact,
} from "./dummydata";

// 👇 Placeholder components for newly separate pages
const Programs = () => <Layout><CourseHome /></Layout>;

function AppInner() {
  const { user } = useAuth();
  const location = useLocation();

  const faqData = useMemo(() => {
    const p = location.pathname;
    if (p === "/" || p.startsWith("/home")) return faqHome;
    if (p.startsWith("/courses") || p.startsWith("/course/")) return faqCourses;
    if (p.startsWith("/programs")) return faqCourses;
    if (p.startsWith("/services/visa")) return faqVisa;
    if (p.startsWith("/services/accommodation")) return faqAccommodation;
    if (p.startsWith("/services/career")) return faqCareer;
    if (p.startsWith("/services/test-prep")) return faqTestPrep;
    if (p.startsWith("/services/documents")) return faqDocuments;
    if (p.startsWith("/services/insurance")) return faqInsurance;
    if (p.startsWith("/services")) return faqServices;
    if (p.startsWith("/country/") || p.startsWith("/destinations/")) return faqCountry;
    if (p.startsWith("/blogs")) return faqBlog;
    if (p.startsWith("/contact")) return faqContact;
    return faqDefault;
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <Header />

      <a
        href="https://wa.me/9115400982"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          right: "20px",
          bottom: "20px",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          backgroundColor: "#25D366",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,.3)",
          zIndex: 50,
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 0 24 24">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      </a>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/events" element={<Events />} />
        <Route path="/courses" element={<CourseHome />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/journal" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/study-abroad" element={<Destinations />} />
        <Route path="/skills" element={<CourseHome />} />
        <Route path="/skills/:category" element={<CourseHome />} />
        <Route path="/degree-programs" element={<CourseHome />} />
        <Route path="/degree-programs/:program" element={<CourseHome />} />
        <Route path="/country/:id" element={<Country />} />
        <Route path="/course/:id" element={<Course />} />
        <Route path="/destinations/:id" element={<Country />} />
        <Route path="/blogs" element={<AllBlogs />} />
        <Route path="/blogs/:slugOrId" element={<Blogs />} />

        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/services/visa" element={<VisaAssistance />} />
        <Route path="/services/accommodation" element={<Accommodation />} />
        <Route path="/services/career" element={<CareerCounseling />} />
        <Route path="/services/test-prep" element={<TestPreparation />} />
        <Route path="/services/documents" element={<DocumentVerification />} />
        <Route path="/services/insurance" element={<TravelInsurance />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/study-abroad-guide" element={<StudyAbroadGuide />} />
        <Route path="/study-abroad-consultant-punjab" element={<LocalSeoGuide />} />
        <Route path="/study-abroad-consultant-bathinda" element={<LocalSeoGuide />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Faq data={faqData} />
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <AppInner />
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}
/* ─────────────────────  End of file  ───────────────────── */
